// extracted by mini-css-extract-plugin
export default {"component":"FormPage_component__eUTWh","knobs":"FormPage_knobs__b-eJf","horizontal":"FormPage_horizontal__ZrmUy","code":"FormPage_code__zX8TJ"};